import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef,
} from "react";
import TableHeader from "../Utility/TableHeader";
import {
  ArrowPathIcon,
  EyeIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { toast } from "react-toastify";
import axios from "axios";
import { DataContext } from "../../helper/HelperOne";
import { use } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Pagination } from "../../helper/HelperTwo";
import { Tooltip } from "react-tooltip";
import { useToast } from "../../context/ToastProvider";
import { logDOM } from "@testing-library/react";
import {
  ChatBubbleBottomCenterIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import { Dialog } from "@headlessui/react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../../App.css";
import Select from "react-select";
import Webcam from "react-webcam";
import { CameraIcon } from "@heroicons/react/24/solid";
import { ArrowPathRoundedSquareIcon } from "@heroicons/react/16/solid";
import { ArrowDownCircleIcon, ArrowUpCircleIcon, MapPinIcon, XCircleIcon } from "lucide-react";

function LeadList({
  setOpenDialogBoxForLead,
  setLeadDetails,
  setSaveBtn,
  setLoading,
  leadPaginationData,
  setEditId,
  fetchLeadDatas,
  setIsEditing,
  setSaveBtnOpen,
  setEditLeadIdCrypty,
  id_crypt,
  showForm,
  filterParams,
  leadDetails,
  // setRequiredFields,
  setLeadDiscussion,
  leadDiscussion,
  setCurrentPage,
  currentPage,
  // Lead,
  topFilter,
  fetchLeadOnly,
  setPreviewImages,
  setExistingImages,
  setDeletedImages,
  leadStatusState,
  unFollowedTypeOfWorkFilter,
  setLeadPhoneData,
}) {
  const [cameraInput, setCameraInput] = useState({
    items: [], // ✅ must not be null
  });

  const tabName = localStorage.getItem("tab_name");
  const [facingMode, setFacingMode] = useState("environment");
  const [webcamFlage, setWebcamFlage] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const webcamRef = useRef(null);

  const videoConstraints = {
    facingMode: facingMode,
    width: { ideal: 1920 },
    height: { ideal: 1080 },
  };

  // const handleCaptureImage = useCallback(() => {
  //   setWebcamFlage(true);
  //   if (!webcamRef.current) return;

  //   const imageSrc = webcamRef.current.getScreenshot();

  //   if (!imageSrc) return;

  //   setCameraInput((prev) => {

  //     const items = [...prev.items];
  
  //     // Ensure item exists
  //     if (!items[index]) {
  //       items[index] = { images: [] };
  //     }

  //     // Ensure images array exists
  //     if (!items[index].images) {
  //       items[index].images = [];
  //     }

  //     // Push image into the array
  //     items[index].images.push(imageSrc);


  //     return { ...prev, items };
  //   });

  //   setShowCapturedImages((prev) => ({
  //     ...prev,
  //     [index]: true,
  //   }));
  // }, [ index, webcamRef, ]);

  // const handleCaptureImage = useCallback(() => {
  //     setWebcamFlage(true);
  //   if (!webcamRef.current) return;

  //   const imageSrc = webcamRef.current.getScreenshot();
  //   if (!imageSrc) return;

  //   setCameraInput((prev) => ({
  //     ...prev,
  //     items: [...prev.items, imageSrc]
  //   }));
  // }, [webcamRef]);

  const handleCaptureImage = useCallback(() => {
    setWebcamFlage(true);
    if (!webcamRef.current) return;

    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) return;

    setCameraInput((prev) => ({
      ...prev,
      items: [...prev.items, imageSrc]   // <-- store directly in items[]
    }));
  }, [webcamRef]);





  const handleSwitchCamera = () => {
    setFacingMode((prev) => (prev === "environment" ? "user" : "environment"));
  };
  const currentLoginIdForAdmin = parseInt(localStorage.getItem("role_id"), 10);
  const currentLoginIdForEmployee = JSON.parse(localStorage.getItem("user"))
    ?.employee?.id;

  const filteredLeads =
    currentLoginIdForAdmin === 1
      ? leadPaginationData?.data || []
      : leadPaginationData?.data;

  const { triggerToast } = useToast();
  const userForView = JSON.parse(localStorage.getItem("user"));
  // const leadPermissionForView = userForView?.lead_role_based_access?.some(
  //   (access) => access.label_id == 6 && access.label_value != 0
  // );

  const userForDelete = JSON.parse(localStorage.getItem("user"));
  // const leadPermissionForDelete = userForDelete?.lead_role_based_access?.some(
  //   (access) => access.label_id == 4 && access.label_value != 0
  // );

  const userForConvertToCustomer = JSON.parse(localStorage.getItem("user"));
  // const convertToCustomerPermission =
  //   userForConvertToCustomer?.lead_role_based_access?.some(
  //     (access) => access.label_id == 5 && access.label_value != 0
  //   );
  const location = useLocation();
  const { lead_id_crypt } = location.state || {};

  const headers = [
    "S No",
    "Enquiry No",
    "Party Name",
    "Mobile No",
    "Contact Person",
    "Sales/Service",
    "Sales Person",
    "Project Manager",
    "Workers",
    "Type of Work",
    "Priority ",
    "City",
    "Created Date",
    "Created Date Difference (One Day)",
    "Next Followup Date",
    "OverDue Days (On Days)",
    "Lead Status",
    "Sync Status",
    "Location",
    "Action",
  ];

  const [leadAllDatas, setLeadAllDatas] = useState([]);
  const { searchData } = useContext(DataContext);
  const [leadId, setLeadId] = useState("");
  const navigate = useNavigate();
  const userId = JSON.parse(localStorage.getItem("user"))?.id;
  const [discussionData, setDiscussionData] = useState([]);
  const [leadDatas, setLeadDatas] = useState([]);
  const [showLossReason, setShowLossReason] = useState(false);
  const [lossReason, setLossReason] = useState([]);
  const [discussion, setDiscussion] = useState({
    message: "",
    lead_id: "",
    status: "",
    next_followup_date: "",
    loss_reason: "",
    worker_tally_id: "",
  });
  const [currentLeadIdCrypt, setCurrentLeadIdCrypt] = useState("");
  const [conversationData, setConversationData] = useState([]);
  const [requiredFields, setRequiredFields] = useState({});

  // const colorClasses = [
  //   "border-blue-500 text-blue-500",
  //   "border-green-500 text-green-500",
  //   "border-red-500 text-red-500",
  //   "border-yellow-500 text-yellow-500",
  //   "border-purple-500 text-purple-500",
  //   "border-pink-500 text-pink-500",
  //   "border-indigo-500 text-indigo-500",
  // ];

  const isDisabled = leadDatas.lead_status === "loss";

  const disabledClass = "bg-gray-100 text-gray-500 cursor-not-allowed";

  const generateBrightColors = (count) => {
    const colors = [];

    for (let i = 0; i < count; i++) {
      const hue = Math.floor(Math.random() * 360); // full range
      const saturation = Math.floor(Math.random() * 40) + 70; // 70–100% bright
      const lightness = Math.floor(Math.random() * 30) + 25; // 25–55% strong colors

      colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
    }

    return colors;
  };

  const colorClasses = generateBrightColors(25);

  const getRandomColorClass = () => {
    return colorClasses[Math.floor(Math.random() * colorClasses.length)];
  };

  const randomColorMap = useMemo(() => {
    const map = {};
    filteredLeads?.forEach((lead) => {
      lead?.type_of_work?.forEach((work) => {
        if (!map[work.id]) {
          map[work.id] = getRandomColorClass(); // now returns HSL color
        }
      });
    });
    return map;
  }, [filteredLeads]);

  // const getRandomColorClass = () => {
  //   return colorClasses[Math.floor(Math.random() * colorClasses.length)];
  // };

  // const randomColorMap = useMemo(() => {
  //   const map = {};
  //   filteredLeads?.forEach((lead) => {
  //     lead?.type_of_work?.forEach((work) => {
  //       if (!map[work.id]) {
  //         map[work.id] = getRandomColorClass();
  //       }
  //     });
  //   });
  //   return map;
  // }, [filteredLeads]);

  const handleViewForLead = async (id_crypt) => {
    // setLoading(true);
    setIsEditing(true);
    setSaveBtnOpen(false);
    setEditLeadIdCrypty(id_crypt);
    setOpenDialogBoxForLead(true);
    // setSaveBtn("update");
    setRequiredFields({
      customer_name: "",
      contact_no: "",
      type_of_work: [],
      sales_service: "",
    });
    setEditId(id_crypt);
    try {
      const response = await axios.get(`public/api/leads/${id_crypt}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

    

      // setDiscussionData(response?.data);

      setDiscussion((prev) => ({
        ...prev,
        status: response?.data?.customer_name,
      }));
        setLeadPhoneData(response?.data.customer);
       
      setLeadDetails((prev) => ({
        ...prev,
        customer_name: response?.data?.customer_name,
        contact_no: response?.data?.contact_no,
        contact_person: response?.data?.contact_person,
        contact_person_no: response?.data?.contact_person_no,
        advertisement_mode_id: response?.data?.advertisement_mode_id,
        sales_service: response?.data?.sales_service,
        worker_tally_id: response?.data?.worker_tally_id,
        worker_name: response?.data?.worker_name,
        salesman_tally_id: response?.data?.salesman_tally_id,
        salesman_name: response?.data?.salesman_name,
        project_manager: response?.data?.project_manager?.name,
        followup_date: response?.data?.followup_date,
        lead_status: response?.data?.lead_status,
        loss_reason: response?.data?.loss_reason?.id,
        city: response?.data?.city,
        address: response?.data?.address,
        type_of_work: response?.data?.type_of_work?.map((item) => item?.name),
        comments: response?.data?.comments,
        priority: response?.data?.priority,
        images: [],
      }));
      setExistingImages(response?.data?.lead_images || []);
      setDeletedImages([]);
      // setPreviewImages(response?.data?.lead_images?.map((item) => item.image));


    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        triggerToast("error", error?.response?.data?.message, "error");
      }

      // toast.error(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchConversations = async (id_crypt) => {
    try {
      const responseForDiscussion = await axios.get(
        `public/api/leads/get-discussion/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );


      setConversationData(responseForDiscussion?.data?.data);

      const lossReasonResponse = await axios.get(
        `public/api/loss-reasons/list`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setLossReason(lossReasonResponse.data);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        triggerToast("error", error?.response?.data?.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchConversations(currentLeadIdCrypt);
  // }, [currentLeadIdCrypt]);

  const handleDiscussionForLead = async (id_crypt) => {
    setLeadDiscussion(true);
    setCurrentLeadIdCrypt(id_crypt);
    try {
      const response = await axios.get(`public/api/leads/${id_crypt}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setLeadDatas(response.data);

      fetchConversations(id_crypt);

      // setDiscussion((prev) => ({
      //   ...prev,
      //   lead_id: response?.data?.id,
      //   worker_tally_id: response?.data?.worker_tally_id,

      // }));
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        triggerToast("error", error.response?.data?.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showForm && id_crypt) {
      handleViewForLead(id_crypt);
    }
  }, [showForm, id_crypt]);

  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);


      setCurrentPage(newPage);
      // fetchLeadDatas(newPage, filterParams);
      fetchLeadOnly(
        newPage,
        topFilter,
        filterParams,
        unFollowedTypeOfWorkFilter
      );
    }
  };

  const handleSendDiscussion = async () => {


    const token = localStorage.getItem("token");
    try {
      const payload = {
        ...discussion,
        images: cameraInput?.items,
      }
      const response = await axios.post(
        `public/api/leads/discussion/${currentLeadIdCrypt}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await fetchConversations(currentLeadIdCrypt);
      setRequiredFields({});
      setWebcamFlage(false)
      setCameraInput({ items: [] });
      setDiscussion({
        message: "",
        status: "",
        loss_reason: "",
        next_followup_date: "",
      });
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {

        setRequiredFields(error.response.data.errors);
      }
    }
  };

  const handleDiscussionChange = (e) => {
    const { name, value } = e.target;
    if (name == "status" && value === "loss") {
      setShowLossReason(true);
    }
    if (name == "status" && (value === "followup" || value === "win")) {
      setShowLossReason(false);
    }
    setDiscussion((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDiscussionClose = () => {
    setLeadDiscussion(false);
    setWebcamFlage(false)
    setRequiredFields({});
    setDiscussion({
      message: "",
      lead_id: "",
      follow_up_status: "",
      loss_reason: "",
      next_followup_date: "",
    });
    setCameraInput({
      items: []
    });
    navigate(location.pathname, {
    state: {
      lead_id_crypt: null,
    },
  });


  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const readers = files.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readers).then((newImages) => {
      setCameraInput((prev) => ({
        ...prev,
        items: [...prev.items, ...newImages]  // <-- append to SAME array
      }));
    });

    e.target.value = "";
  };



  return (
    <>
      <div className="overflow-x-auto mt-8">
        <table className="min-w-full border border-gray-300 border-collapse">
          <TableHeader headers={headers} />
          <tbody>
            {filteredLeads?.length > 0 ? (
              filteredLeads.map((lead, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="border border-gray-300 whitespace-nowrap text-md sm:pl-4 text-center">
                    {leadPaginationData?.from + index}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.enquiry_no || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.customer_name || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-blue-500 sm:pl-4 text-center p-5">
                    <a href={`tel:${lead?.contact_no}`}>
                      {" "}
                      {lead?.contact_no || "N/A"}{" "}
                    </a>
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.contact_person || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.sales_service || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.salesman?.name || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.project_manager || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.worker?.name || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-wrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.type_of_work && lead?.type_of_work?.length > 0 ? (
                      <div className="flex flex-wrap gap-2 justify-center">
                        {lead?.type_of_work?.map((work) => (
                          <span
                            className="px-3 py-1 border rounded text-xs"
                            style={{
                              borderColor: randomColorMap[work?.id],
                              color: randomColorMap[work?.id],
                            }}
                          >
                            {work?.name || "N/A"}
                          </span>
                        ))}
                      </div>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.priority ?? "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead?.city ?? "N/A"}
                  </td>

                    <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead.created_at
                      ? new Date(lead.created_at).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                      : "N/A"}
                  </td>
                   <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {lead.createdDayDiff || "0"}
                  </td>
                  <td
                    className={`border border-gray-300 whitespace-nowrap text-md sm:pl-4 text-center p-5 ${lead?.next_followup_date
                      ? (() => {
                        const today = new Date();
                        const date = new Date(lead?.next_followup_date);

                        const todayDate = new Date(
                          today.getFullYear(),
                          today.getMonth(),
                          today.getDate()
                        );
                        const compareDate = new Date(
                          date.getFullYear(),
                          date.getMonth(),
                          date.getDate()
                        );

                        if (compareDate.getTime() === todayDate.getTime()) {
                          return "text-yellow-500"; // Today
                        } else if (
                          compareDate.getTime() < todayDate.getTime()
                        ) {
                          return "text-red-500"; // Past
                        } else {
                          return "text-green-500"; // Future
                        }
                      })()
                      : "text-gray-500"
                      }`}
                  >
                    {lead.next_followup_date
                      ? new Date(lead.next_followup_date).toLocaleString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        }
                      )
                      : "N/A"}
                  </td>
                  <td
                    className={`border border-gray-300 whitespace-nowrap text-md text-center p-5 sm:pl-4 
                       ${lead.overdueDays === 0
                        ? "text-yellow-500" // 0 → yellow
                        : lead.overdueDays > 0
                          ? "text-green-500" // greater than 0 → green
                          : "text-gray-500" // less than 0 → red
                      } `}
                  >
                    {lead.overdueDays}
                  </td>

                  <td
                    className={`border border-gray-300 whitespace-nowrap text-md uppercase sm:pl-4 text-center p-5 ${lead.lead_status?.toLowerCase() === "win"
                      ? "text-green-500"
                      : lead.lead_status?.toLowerCase() === "loss"
                        ? "text-red-500"
                        : lead.lead_status?.toLowerCase() === "followup"
                          ? "text-blue-500"
                          : "text-gray-500"
                      }`}
                  >
                    {lead.lead_status == "loss"
                      ? "Lost"
                      : lead.lead_status || "N/A"}
                  </td>
                  <td
                    className={`border border-gray-300 whitespace-nowrap text-md  ${lead.sync_status == 0 ? "text-red-500" : "text-green-500"
                      } sm:pl-4 text-center p-5`}
                  >
                    {lead.sync_status == 0 ? "Not Synced" : "Synced"}
                  </td>
                
                 
                  <td
                    className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                  >
                    {lead?.location ? (
                      <>
                        <a
                          href={lead.location}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="my-anchor-Location text-blue-600 underline inline-flex justify-center"
                        >
                          <MapPinIcon className="h-5 w-5 text-blue-500" />
                        </a>

                        <Tooltip
                          anchorSelect=".my-anchor-Location"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          Location
                        </Tooltip>
                      </>
                    ) : (
                      "-"
                    )}
                  </td>


                  <td className="border border-gray-300 whitespace-nowrap text-center align-middle p-5">
                    <div className="flex space-x-2 justify-center items-center">
                      {(userId == 1 || userId == 2) && (
                        <span
                          className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                          onClick={() =>
                            handleViewForLead(
                              lead.id_crypt,
                              setOpenDialogBoxForLead
                            )
                          }
                        >
                          <EyeIcon className="h-5 w-5 text-white" />
                          <Tooltip
                            anchorSelect=".my-anchor-view"
                            place="top"
                            className="text-xs p-0"
                            style={{ fontSize: "12px", padding: "0.3rem" }}
                          >
                            View
                          </Tooltip>
                        </span>
                      )}

                      <span
                        className="my-anchor-discussion relative group cursor-pointer bg-orange-400 rounded-md p-1"
                        onClick={() =>
                          handleDiscussionForLead(
                            lead.id_crypt,
                            setOpenDialogBoxForLead
                          )
                        }
                      >
                        <ChatBubbleBottomCenterIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-discussion"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          Discussion
                        </Tooltip>
                      </span>

                      {(userId == 1 || userId == 2) && (
                        <DeleteConfirmation
                          id_crypt={lead.id_crypt}
                          apiType={"lead"}
                          fetchClientData={fetchLeadDatas}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="12"
                  className="border border-gray-300 text-center py-4 text-gray-500"
                >
                  No leads found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {leadDiscussion && (
        <Dialog
          open={leadDiscussion}
          onClose={() => { }}
          className="relative z-10"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
              <Dialog.Panel className="relative transform overflow-hidden p-2 sm:p-0 rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-5xl sm:p-4">
                {/* Title & Close */}
                <div className="flex items-center justify-between p-4 border border-gray-200 rounded-t-md">
                  <h3 className="text-lg sm:text-md font-semibold text-blue-800">
                    Lead Follow Up
                  </h3>
                  <XMarkIcon
                    onClick={handleDiscussionClose}
                    className="h-8 w-8 cursor-pointer bg-red-600 rounded-full text-white p-2"
                  />
                </div>

                {/* Content: Left + Right */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-4  border  border-gray-200 rounded-b-md">
                  {/* LEFT SIDE FORM */}
                  <div className="md:col-span-2 space-y-2">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Party / Company Name
                      </label>
                      <p className="mt-1 font-medium text-blue-700">
                        {leadDatas.customer_name ?? "N/A"}
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {discussion?.status === "followup" && (
                        <div className="mt-4">
                          <label className="block text-sm font-medium text-gray-700">
                            Follow Up Note
                            <span className="text-red-500">*</span>
                          </label>
                          <textarea
                            name="message"
                            value={discussion.message}
                            onChange={handleDiscussionChange}
                            className={`mt-1 w-full border border-gray-300 rounded px-3 py-2 ${isDisabled ? disabledClass : ""
                              }`}
                            rows={4}
                            placeholder="Write follow-up note..."
                            disabled={isDisabled}
                          />
                          {requiredFields && (
                            <p className="text-red-500 text-xs mt-1">
                              {requiredFields.message}
                            </p>
                          )}
                        </div>
                      )}

                      <div className="mt-4">
                        <div className="mb-2">
                          <div className="w-full">
                            <label className="block text-sm font-medium text-gray-700">
                              Select Status
                            </label>
                            <select
                              name="status"
                              value={discussion.status}
                              onChange={handleDiscussionChange}
                              className={`mt-1 w-full border border-gray-300 rounded px-3 py-2 ${isDisabled ? disabledClass : ""
                                }`}
                              disabled={isDisabled}
                            >
                              <option value="">Select Status</option>
                              <option value="followup">Follow Up</option>
                              <option value="win">Win</option>
                              <option value="loss">Lost</option>
                            </select>
                            {requiredFields && (
                              <p className="text-red-500 text-xs mt-1">
                                {requiredFields.status}
                              </p>
                            )}
                          </div>

                          {/* Show only if status = followup */}
                          {discussion.status === "followup" && (
                            <div className="w-full mt-4">
                              <label className="block text-sm font-medium text-gray-700">
                                Next Follow Up Date
                              </label>
                              <input
                                type="date"
                                name="next_followup_date"
                                value={discussion.next_followup_date}
                                onChange={handleDiscussionChange}
                                className={`mt-1 w-full border border-gray-300 rounded px-3 py-2 ${isDisabled ? disabledClass : ""
                                  }`}
                                disabled={isDisabled}
                              />
                              {requiredFields && (
                                <p className="text-red-500 text-xs mt-1">
                                  {requiredFields.next_followup_date}
                                </p>
                              )}
                            </div>
                          )}

                          {showLossReason && (
                            <div className="w-full mt-4">
                              <label className="block text-sm font-medium text-gray-700">
                                Lost Reason
                                <span className="text-red-600"> *</span>
                              </label>
                              <Select
                                name="loss_reason"
                                options={lossReason?.map((reason) => ({
                                  value: reason.id,
                                  label: reason.reason,
                                }))}
                                value={
                                  lossReason
                                    ?.map((reason) => ({
                                      value: reason.id,
                                      label: reason.reason,
                                    }))
                                    .find(
                                      (reason) =>
                                        reason.value == discussion?.loss_reason
                                    ) || null
                                }
                                onChange={(selectedOption) =>
                                  handleDiscussionChange({
                                    target: {
                                      name: "loss_reason",
                                      value: selectedOption?.value || "",
                                      worker: selectedOption?.label || "",
                                    },
                                  })
                                }
                                isMulti={false}
                                placeholder="Select Loss Reason"
                                className="mt-1"
                                classNamePrefix="select"
                              />
                              {requiredFields && (
                                <p className="text-red-500 text-xs mt-1">
                                  {requiredFields.loss_reason}
                                </p>
                              )}
                            </div>
                          )}
                        </div>

                        <button
                          onClick={handleSendDiscussion}
                          className="mt-4 bg-blue-600 text-white w-full md:w-auto flex justify-center font-medium px-6 py-2 rounded-md hover:bg-blue-700"
                        >
                          Update Lead
                        </button>
                      </div>
                    </div>

                    <div>

                      {webcamFlage && (
                        <Webcam
                          audio={false}
                          ref={webcamRef}
                          screenshotFormat="image/png"
                          screenshotQuality={1}
                          videoConstraints={videoConstraints}
                          className="w-64 h-48 rounded border border-gray-300"
                        />
                      )}


                      <div className="flex gap-2 mt-2 justify-start">
                        <button
                          type="button"
                          onClick={handleCaptureImage}
                          className="bg-[#134b90] text-white px-4 py-2 rounded hover:bg-blue-700"
                        >
                          <CameraIcon className="h-5 w-5" />
                        </button>

                        <button
                          type="button"
                          onClick={handleSwitchCamera}
                          className="bg-[#134b90] text-white px-4 py-2 rounded hover:bg-blue-700"
                        >
                          <ArrowPathRoundedSquareIcon className="h-5 w-5" />
                        </button>

                        {webcamFlage && (
                          <button
                            type="button"
                            onClick={() => setWebcamFlage(false)}
                            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700"
                          >
                            <XCircleIcon className="h-5 w-5" />
                          </button>
                        )}

                        <div>
                          <input
                            type="file"
                            id="files"
                            name="files"
                            accept="image/*"
                            onChange={handleFileChange}
                            multiple
                            className="hidden"
                          />
                          <button
                            type="button"
                            onClick={() => document.getElementById("files").click()}
                            className="bg-[#134b90] text-white px-4 py-2 rounded hover:bg-blue-700"
                          >


                            <ArrowUpCircleIcon className="h-5 w-5" />
                          </button>
                        </div>




                      </div>
                      {cameraInput.items?.length > 0 && (
                        <div className="mt-4">
                          <label className="block text-sm font-medium text-gray-700">
                            Camera Input
                          </label>


                          <div className="grid grid-cols-3 gap-4 mt-4">
                            {cameraInput.items.map((img, i) => (
                              <div key={i} className="relative">

                                {/* Image */}
                                <img
                                  src={img}
                                  className="w-full  h-30 rounded border"
                                  alt={`image-${i}`}
                                />

                                {/* Delete Button */}
                                <button
                                  type="button"
                                  onClick={() => {
                                    setCameraInput((prev) => {
                                      const updatedItems = prev.items.filter((_, index) => index !== i);
                                      return { items: updatedItems };
                                    });
                                  }}
                                  className="absolute top-1 right-1 bg-red-600 text-white text-xs px-2 py-1 rounded"
                                >
                                  ✕
                                </button>

                              </div>
                            ))}
                          </div>


                        </div>
                      )}




                    </div>
                    {/* FOLLOW UP HISTORY */}
                    <div className="border sm:border-0 p-3 rounded-md sm:rounded-none p-0 mx-auto">
                      <h4 className="inline-block text-sm font-semibold bg-blue-100 text-blue-800 px-3 py-1 rounded shadow-sm">
                        Follow Up's
                      </h4>

                      {conversationData.length > 0 ? (
                        <div className="space-y-4 mt-2 h-[300px] overflow-y-scroll">
                          {conversationData.map((item, index) => (
                            <div key={index} className="space-y-1">
                              {/* Worker Tally ID and Status in same row */}
                              <div className="flex justify-between text-xs font-semibold text-gray-600">
                                <p>{item.worker_tally_id}</p>
                                <p>
                                  Status :{" "}
                                  {item.status?.charAt(0).toUpperCase() +
                                    item.status?.slice(1)}
                                </p>
                              </div>

                              {/* Message Bubble */}
                              <div className="bg-gray-200 text-gray-800  px-4 py-2 rounded-lg ">
                                {item.message}
                                {item?.discussion_images?.length > 0 && (
                                  <div className={` gap-1 mt-4 flex  `}>
                                    {item?.discussion_images?.map((img, i) => {
                                      const baseURL = axios.defaults.baseURL?.replace(/\/$/, "");
                                      const filePath = img?.image?.replace(/^\//, "");
                                      const fullURL = `${baseURL}/${filePath}`;
                                      return (
                                        <div key={i} className="relative  h-auto w-20">
                                          <img
                                            src={fullURL}
                                            className="w-full h-full object-cover rounded border cursor-pointer"
                                            alt={`image-${i}`}
                                            onClick={() => setPreviewImage(fullURL)}  // 👈 Open popup
                                          />
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>

                              {previewImage && (
                                <div
                                  className="fixed inset-0 bg-gray-100 bg-opacity-60 flex items-center justify-center z-50 p-4 h-full  w-full"
                                  onClick={() => setPreviewImage(null)} // close when clicking background
                                >
                                  <div className="relative bg-white p-3 rounded shadow-lg">
                                    <button
                                      className="absolute top-1 right-1 bg-red-600 text-white px-2 py-1 text-sm rounded"
                                      onClick={() => setPreviewImage(null)}
                                    >
                                      ✕
                                    </button>

                                    <img
                                      src={previewImage}
                                      className=" object-contain rounded h-[500px] w-full"
                                      alt="Preview"
                                    />
                                  </div>
                                </div>
                              )}


                              {/* Dates in same row */}
                              <div className="flex justify-end">
                                <div className=" text-xs text-gray-500 ">
                                  <p>
                                    <mark className="bg-white">
                                      Next Follow Up :
                                    </mark>{" "}
                                    {item.next_followup_date}
                                  </p>
                                  <p className="mt-2 text-right">
                                    <mark className="bg-white text-right">
                                      Posted :
                                    </mark>{" "}
                                    {item.created_at.split("T")[0]}
                                  </p>
                                  {/* <p className="text-right">{item.created_at.split("T")[0]}</p> */}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="space-y-4">
                          <div className="max-w-xs">
                            <p className="text-xs font-semibold text-gray-600 mb-1 mt-4">
                              No Conversation Found
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* RIGHT SIDE INFO CARD */}
                  <div className="bg-gray-50 border rounded-md p-4 shadow-sm space-y-3 text-sm text-gray-800">
                    {leadDatas ? (
                      <div className="bg-gray-50 space-y-3 text-sm text-gray-800 mb-4">
                        {/* Party Name */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-xs text-gray-600 min-w-[100px]">
                            <span>👤</span>
                            <span>Party / Company Name</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[70%]">
                            {leadDatas.customer_name ?? "N/A"}
                          </div>
                        </div>

                        {/* Mobile No */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>📋</span>
                            <span>Mobile No</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.contact_no ?? "N/A"}
                          </div>
                        </div>

                        {/* Type of Work */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>📁</span>
                            <span>Type of Work</span>
                          </div>
                          <div className="flex flex-wrap justify-end gap-1 max-w-[60%]">
                            {leadDatas.type_of_work &&
                              leadDatas.type_of_work.length > 0 ? (
                              leadDatas.type_of_work.map((work, index) => (
                                <span
                                  key={index}
                                  className="bg-blue-100 text-blue-800 text-right text-xs font-medium px-2 py-0.5 rounded"
                                >
                                  {work.name}
                                </span>
                              ))
                            ) : (
                              <span className="text-sm text-gray-500">N/A</span>
                            )}
                          </div>
                        </div>

                        {/* Sales/Service */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>🔗</span>
                            <span>Sales/Service</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.sales_service ?? "N/A"}
                          </div>
                        </div>

                        {/* Workers */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>🕒</span>
                            <span>Workers</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.worker_name ?? "N/A"}
                          </div>
                        </div>

                        {/* Sales Man */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>✅</span>
                            <span>Sales Man</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.salesman_name ?? "N/A"}
                          </div>
                        </div>

                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>📆</span>
                            <span>1st Followup Date</span>
                          </div>
                          {/* <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.followup_date ?? "N/A"}
                          </div> */}
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.followup_date
                              ? new Date(
                                leadDatas.followup_date
                              ).toLocaleDateString("en-GB") // dd/mm/yyyy
                              : "N/A"}
                          </div>
                        </div>

                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>📆</span>
                            <span>Next Followup Date</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {/* {leadDatas.next_followup_date ?? "N/A"} */}
                            {leadDatas.next_followup_date
                              ? new Date(
                                leadDatas.next_followup_date
                              ).toLocaleDateString("en-GB") // dd/mm/yyyy
                              : "N/A"}
                          </div>
                        </div>

                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>⌛</span>
                            <span>Lead Status</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.lead_status?.charAt(0).toUpperCase() +
                              leadDatas.lead_status?.slice(1) ?? "N/A"}
                          </div>
                        </div>

                        {/* Advertisement Mode */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>📢</span>
                            <span>Advertisement Mode</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.advertisement_mode?.name ?? "N/A"}
                          </div>
                        </div>

                        {/* Contact Person Mode */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>👤</span>
                            <span>Contact Person Name</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.contact_person ?? "N/A"}
                          </div>
                        </div>

                        {/* Contact No */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>📞</span>
                            <span>Contact No</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.contact_person_no ?? "N/A"}
                          </div>
                        </div>

                        {/* Address */}
                        <div className="flex justify-between border-b pb-3">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>📍</span>
                            <span>Address</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.address ?? "N/A"}
                          </div>
                        </div>

                        <div className="flex justify-between">
                          <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                            <span>💬</span>
                            <span>Comments</span>
                          </div>
                          <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.comments ?? "N/A"}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center text-gray-600">
                        No lead data found.
                      </div>
                    )}
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      )}

      {leadPaginationData && (
        <Pagination
          links={leadPaginationData.links}
          currentPage={leadPaginationData.current_page}
          totalResults={leadPaginationData.total}
          from={leadPaginationData.from}
          to={leadPaginationData.to}
          lastPage={leadPaginationData.last_page}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
}

export default LeadList;
